import { call, takeEvery, put } from "redux-saga/effects";

import { searchPeople, searchPeopleSuccess, searchPeopleFailure } from "../actions";
import { searchPeopleRequest } from "../api";
import { searchPeopleData } from "src/types/form";
import _ from "lodash";
import { addUsers } from "src/modules/users/actions";

function* getTemplatesSaga(actions: any) {
  try {
    const { payload } = actions;
    const people: searchPeopleData[] = yield call(searchPeopleRequest, payload);
    let emails: any = [];
    if (people.length > 0) {
      people.map((user: any) => {
        let email = user.AccountName.split("|")[user.AccountName.split("|").length - 1];
        emails = [...emails, email];
      });
    }
    yield put(searchPeopleSuccess(people));
    if (emails.length > 0) {
      yield put(addUsers([..._.uniqWith(emails, _.isEqual)]));
    }
  } catch (error) {
    console.log(error);
    yield put(searchPeopleFailure(error));
  }
}

export function* searchPeopleWatcher() {
  yield takeEvery(searchPeople.toString(), getTemplatesSaga);
}
